import { render, staticRenderFns } from "./JinNangTabs.vue?vue&type=template&id=2da30d7e&scoped=true&"
import script from "./JinNangTabs.vue?vue&type=script&lang=js&"
export * from "./JinNangTabs.vue?vue&type=script&lang=js&"
import style0 from "./JinNangTabs.vue?vue&type=style&index=0&id=2da30d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da30d7e",
  null
  
)

export default component.exports